export const getUsageDataTooltipText = (dataType: 'sessions' | 'tests'): string =>
	`Includes only ${dataType} uploaded to the platform. Comparisons use the previous period if available.`;
